export default __webpack_public_path__ + "assets/images/58dbd98ddc94e893d8710cd826cb3ffd.gif";